/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {CouponQueueAddDto} from '../models/CouponQueueAddDto'
import type {CouponQueueDetailDtoListSuccessDataResult} from '../models/CouponQueueDetailDtoListSuccessDataResult'
import type {CouponQueueDetailDtoSuccessDataResult} from '../models/CouponQueueDetailDtoSuccessDataResult'
import type {CancelablePromise} from '../core/CancelablePromise'
import {CouponQueueDetailDto, OpenAPICouponCenter} from 'rest'
import {request as __request} from '../core/request'
import {PaginatedResult} from 'rest/types/PaginatedResult'

export type SortPayloadType = {
  items: {
    id: string
    sort_number: string
  }[]
}

export const transformCoupon = (item: Record<string, any>) => {
  return {
    id: item.id,
    couponId: item.id,
    typeId: item.offer_type,
    merchantId: item.store.id,
    description: item.description,
    headline: item.title,
    destinationUrl: item.custom_url,
    code: item.discount_code,
    minimum: item.minimum_order_amount,
    minAmount: item.minimum_order_amount,
    savings: item.savings_amount || item.savings_percent,
    isSavingsRange: item.title?.toLowerCase()?.includes('up to'),
    isFreeShipping: item.offer_type === 'free shipping',
    started: item.start_date,
    expired: item.expiration_date,
    isApproved: item.approved,
  }
}

export const transformResponse = <T, R>(
  responseData: PaginatedResult<T>
): any => {
  const results = responseData.results.map((item: Record<string, any>) => {
    const transformedItem = transformCoupon(item)
    return transformedItem
  })

  return {
    ...responseData, // Keep other pagination metadata like count, next, and previous
    results, // Replace the original results with the transformed results
  }
}

export class CouponQueueService {
  /**
   * @param requestBody
   * @returns CouponQueueDetailDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static updateApiCoupon(
    requestBody?: CouponQueueAddDto
  ): CancelablePromise<CouponQueueDetailDtoSuccessDataResult> {
    const storeId = JSON.parse(localStorage.getItem('user'))?.store?.id

    console.log('requestBody', requestBody)
    return __request(OpenAPICouponCenter, {
      method: 'PATCH',
      url: `/api/v1/coupons/${requestBody.couponId}`,
      body: {
        ...requestBody,
        offer_type: requestBody.typeId,
        approved: true,
        custom_url: requestBody.destinationUrl,
        description: requestBody.description,
        destination_affiliate_url: requestBody.destinationUrl,
        destination_coupon_url: requestBody.destinationUrl,
        discount_code: requestBody.code,
        expiration_date: requestBody.expired ? requestBody.expired : null,
        savings_amount: requestBody.savings,
        savings_minimum_order: requestBody.minimum,
        savings_percent: requestBody.savings,
        start_date: requestBody.started ? requestBody.started : null,
        store: storeId,
        title: requestBody.headline,
        up_to_savings_percent: 0,
      },
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  public static updateSortOrder(
    payload: SortPayloadType
  ): CancelablePromise<{message: string; success: boolean}> {
    return __request(OpenAPICouponCenter, {
      method: 'POST',
      url: '/api/v1/coupons/sort-coupons',
      body: {
        items: payload.items,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param couponId
   * @returns CouponQueueDetailDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiCouponQueueGetByCouponId(
    couponId?: number
  ): CancelablePromise<CouponQueueDetailDtoListSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/CouponQueue/GetByCouponId',
      query: {
        couponId: couponId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
  /**
   * @param merchantId
   * @returns CouponQueueDetailDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiCouponQueueGetByMerchantId(): CancelablePromise<
    PaginatedResult<CouponQueueDetailDto>
  > {
    const storeClient = JSON.parse(localStorage.getItem('user'))?.store?.client
    const storeSlug = JSON.parse(localStorage.getItem('user'))?.store?.slug
    return __request(OpenAPICouponCenter, {
      transformResponse: transformResponse,
      method: 'GET',
      url: `/api/v1/coupons`,
      query: {
        store_slug: storeSlug,
        client: storeClient,
        include_scheduled: '1',
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
